import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockContainerComponent } from './block-container.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockHtmlModule } from '@app/components/blocks/block-html/block-html.module';
import { BlockTextboxModule } from '@app/components/blocks/block-textbox/block-textbox.module';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, BlockHtmlModule, BlockTextboxModule],
  declarations: [BlockContainerComponent],
  exports: [BlockContainerComponent],
})
export class BlockContainerModule {}
